import React, { Component, PureComponent } from 'react'
import { Button, TableRow, TableCell, Table, TableHead, TableBody, Paper } from '@material-ui/core'

import { leaflyCategoryList } from '../../utils/constants'
import { updateAtIndex, deleteAtIndex, convertArrayToOptions } from '../../utils/array'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import LeaflyMapCategoryItem from './LeaflyMapCategoryItem'
import { hasAccess } from '../../utils/api'

const LeaflyMapCategoryItemEditable = EditableHOCWrapper(LeaflyMapCategoryItem)

class LeaflyMapCategories extends Component {
  state = {
    newCategory: false,
  }

  onSave = (index) => (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    let { leaflyAccount = {} } = this.props
    const { categoryMapping = [] } = leaflyAccount

    const newCategories = updateAtIndex(categoryMapping, index, data)
    leaflyAccount = { ...leaflyAccount, categoryMapping: newCategories }

    this.props.onSave(leaflyAccount, afterOnSave)
  }

  onDelete = (index) => (data) => {
    let { leaflyAccount = {} } = this.props
    const { categoryMapping = [] } = leaflyAccount

    const newCategories = deleteAtIndex(categoryMapping, index)
    leaflyAccount = { ...leaflyAccount, categoryMapping: newCategories }
    this.props.onSave(leaflyAccount, () => {})
  }

  saveNewCategory = (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    let { leaflyAccount = {} } = this.props
    const { categoryMapping = [] } = leaflyAccount

    const newCategories = [...categoryMapping]
    newCategories.push({ ...data, flowerType: null })
    leaflyAccount = { ...leaflyAccount, categoryMapping: newCategories }
    this.props.onSave(leaflyAccount, afterOnSave)

    this.setState({
      newCategory: false,
    })
  }

  openNewCategory = () => {
    this.setState({
      newCategory: true,
    })
  }

  closeNewCategory = () => {
    this.setState({
      newCategory: false,
    })
  }

  validate = (data) => {
    if (!data.categoryId) {
      this.props.onError('Please choose a category')
      return false
    }

    if (!data.leaflyCategory) {
      this.props.onError('Please choose a Leafly category')
      return false
    }

    return true
  }

  render() {
    const { leaflyAccount = {}, categoryList = [], lastModified = null } = this.props
    const { newCategory = false } = this.state
    const { categoryMapping = [] } = leaflyAccount

    const assignedCategories = categoryMapping.map((menu, index) => {
      return menu.categoryId
    })
    const availableCategoryList = categoryList.filter(
      (category) => !assignedCategories.includes(category.id),
    )

    return (
      <div className="table-scroll">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>BLAZE Categories</TableCell>
                <TableCell>Leafly Categories</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categoryMapping.map((menu, index) => {
                return (
                  <LeaflyMapCategoryItemEditable
                    onSave={this.onSave(index)}
                    dataToEdit={menu}
                    mapping={menu}
                    lastModified={lastModified}
                    leaflyCategoryList={leaflyCategoryList}
                    categoryList={categoryList}
                    availableCategoryList={availableCategoryList}
                    onDelete={this.onDelete(index)}
                    key={index}
                  />
                )
              })}
              {newCategory ? (
                <LeaflyMapCategoryItemEditable
                  onSave={this.saveNewCategory}
                  dataToEdit={{}}
                  mapping={{}}
                  lastModified={lastModified}
                  leaflyCategoryList={leaflyCategoryList}
                  categoryList={categoryList}
                  availableCategoryList={availableCategoryList}
                  onCancel={this.closeNewCategory}
                  defaultEditMode={true}
                />
              ) : null}
            </TableBody>
          </Table>
          {hasAccess() && !newCategory && availableCategoryList.length > 0 ? (
            <Button
              className="primary-button addMoreButton margin-bottom-small"
              onClick={this.openNewCategory}
            >
              + Add More
            </Button>
          ) : null}
        </Paper>
      </div>
    )
  }
}

export default LeaflyMapCategories



// WEBPACK FOOTER //
// ./src/components/Leafly/LeaflyMapCategories.js